/** @format */

import { BUILD_CONFIG } from '../../utils/build_config';
/*
 * NOTE:
 * id is the value to be passed to the API, name is the value to be passed to intl
 * The decision to keep them separate is to allow changing the id in the future
 * (in case we change the api to accept an actual id)
 */

export type CityType = {
  id: string;
  name: string;
} & (MajorCityType | SubCityType);

export type MajorCityType = {
  country: 'it' | 'fr' | 'es';
  shared_apartments: boolean;
  buildings: boolean;
  order: number;
  discover: boolean;
  hot: boolean;
  belongs_to?: never;
} & (InternalCityType | ExternalCityType | SubCityType);

type InternalCityType = {
  redirect: false;
  code: string;
};

type ExternalCityType = {
  redirect: true;
  code?: never;
};

type SubCityType = {
  country?: never;
  shared_apartments?: never;
  buildings?: never;
  order?: never;
  hot?: never;
  belongs_to: string;
};

const CITIES_RAW: CityType[] = [
  {
    id: 'bologna',
    name: 'bologna',
    country: 'it',
    hot: false,
    shared_apartments: true,
    buildings: true,
    order: 3,
    redirect: false,
    discover: true,
    code: 'BO',
  },
  {
    id: 'bordeaux',
    name: 'bordeaux',
    country: 'fr',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 2,
    redirect: false,
    discover: false,
    code: 'B1',
  },
  {
    id: 'como',
    name: 'como',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 8,
    redirect: true,
    discover: false,
  },
  {
    id: 'corsico',
    name: 'corsico',
    belongs_to: 'milan',
  },
  {
    id: 'vimodrone',
    name: 'vimodrone',
    belongs_to: 'milan',
  },
  {
    id: 'cesano_boscone',
    name: 'cesano_boscone',
    belongs_to: 'milan',
  },
  {
    id: 'sesto_san_giovanni',
    name: 'sesto_san_giovanni',
    belongs_to: 'milan',
  },
  {
    id: 'ferrara',
    name: 'ferrara',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 9,
    redirect: true,
    discover: false,
  },
  {
    id: 'florence',
    name: 'florence',
    country: 'it',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 5,
    redirect: false,
    discover: false,
    code: 'FI',
  },
  {
    id: 'lille',
    name: 'lille',
    country: 'fr',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 3,
    redirect: false,
    discover: false,
    code: 'L1',
  },
  {
    id: 'lyon',
    name: 'lyon',
    country: 'fr',
    hot: true,
    shared_apartments: true,
    buildings: false,
    order: 5,
    redirect: false,
    discover: false,
    code: 'L2',
  },
  {
    id: 'madrid',
    name: 'madrid',
    country: 'es',
    hot: false,
    shared_apartments: true,
    buildings: true,
    order: 1,
    redirect: false,
    discover: true,
    code: 'MA',
  },
  {
    id: 'milan',
    name: 'milan',
    country: 'it',
    hot: true,
    shared_apartments: true,
    buildings: true,
    order: 1,
    redirect: false,
    discover: true,
    code: 'MI',
  },
  {
    id: 'montpellier',
    name: 'montpellier',
    country: 'fr',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 4,
    redirect: false,
    discover: false,
    code: 'M1',
  },
  {
    id: 'padua',
    name: 'padua',
    country: 'it',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 7,
    redirect: false,
    discover: true,
    code: 'PD',
  },
  {
    id: 'paris',
    name: 'paris',
    country: 'fr',
    hot: true,
    shared_apartments: true,
    buildings: false,
    order: 2,
    redirect: false,
    discover: false,
    code: 'PI',
  },
  {
    id: 'parma',
    name: 'parma',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 10,
    redirect: true,
    discover: false,
  },
  {
    id: 'rome',
    name: 'rome',
    country: 'it',
    hot: true,
    shared_apartments: true,
    buildings: false,
    order: 2,
    redirect: false,
    discover: true,
    code: 'RM',
  },
  {
    id: 'siena',
    name: 'siena',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 11,
    redirect: true,
    discover: false,
  },
  {
    id: 'toulouse',
    name: 'toulouse',
    country: 'fr',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 6,
    redirect: false,
    discover: false,
    code: 'T1',
  },
  {
    id: 'trento',
    name: 'trento',
    country: 'it',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 6,
    redirect: false,
    discover: true,
    code: 'TN',
  },
  {
    id: 'trieste',
    name: 'trieste',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 13,
    redirect: true,
    discover: false,
  },
  {
    id: 'turin',
    name: 'turin',
    country: 'it',
    hot: false,
    shared_apartments: true,
    buildings: false,
    order: 4,
    redirect: false,
    discover: true,
    code: 'TO',
  },
  {
    id: 'venice',
    name: 'venice',
    country: 'it',
    hot: false,
    shared_apartments: false,
    buildings: true,
    order: 14,
    redirect: true,
    discover: false,
  },
];

const MAJOR_CITIES = CITIES_RAW.filter(city => typeof city.belongs_to !== 'string');
export const MINOR_CITIES = CITIES_RAW.filter(city => typeof city.belongs_to === 'string');

export const CITIES = MAJOR_CITIES.filter(city => {
  const { country } = city;
  if (BUILD_CONFIG.buildCountries().includes(country)) return true;
  return false;
});

export const CITIES_INTERNAL = MAJOR_CITIES.filter(city => !city.redirect);
export const CITIES_EXTERNAL = MAJOR_CITIES.filter(city => city.redirect);
export const CITIES_DISCOVER = MAJOR_CITIES.filter(city => city.discover);
